import { deprecated } from "@gr-common/head/logger";

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
/*                 */
export const add = deprecated(
  <
    T extends HTMLElement,
    K extends keyof HTMLElementEventMap,
    F extends (this: HTMLElement, ev: HTMLElementEventMap[K]) => void,
  >(
    obj: T,
    type: K,
    fn: F,
    useCapture = false,
  ): void => obj.addEventListener(type, fn, useCapture),
  "event",
  "add",
  "use native addEventListener instead",
);

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const remove = deprecated(
  <
    T extends HTMLElement,
    K extends keyof HTMLElementEventMap,
    F extends (this: HTMLElement, ev: HTMLElementEventMap[K]) => void,
  >(
    obj: T,
    type: K,
    fn: F,
  ): void => obj.removeEventListener(type, fn, false),
  "event",
  "remove",
  "use native removeEventListener instead",
);

/**
 *
 *
 *
 *
 *
 *
 *
 */
export const stopPropagation = deprecated(
  <T extends Event>(event: T): void => event.stopPropagation(),
  "event",
  "stopPropagation",
  "use native event.stopPropagation instead",
);

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const getTarget = deprecated(
  <T extends Event>(event: T): EventTarget | null => event.target,
  "event",
  "getTarget",
  "use native event.target instead",
);

/**
 *
 *
 *
 *
 *
 *
 *
 */
export const preventDefault = deprecated(
  <T extends Event>(event: T): void => event.preventDefault(),
  "event",
  "preventDefault",
  "use native event.preventDefault instead",
);

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const trigger = deprecated(
  <T extends Element>(element: T, type: string): void => {
    const event = document.createEvent("HTMLEvents");
    event.initEvent(type, true, true);
    element.dispatchEvent(event);
  },
  "event",
  "trigger",
  "use native CustomElements instead",
);
/*                */
